import { render, staticRenderFns } from "./AnnotationForm.vue?vue&type=template&id=7d759f0b&scoped=true&"
import script from "./AnnotationForm.vue?vue&type=script&lang=js&"
export * from "./AnnotationForm.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationForm.vue?vue&type=style&index=0&id=7d759f0b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d759f0b",
  null
  
)

export default component.exports